module.exports = __webpack_public_path__ + "img/item6-2.ea11ef1d.png";